import { useCallback } from 'react';
import { communityTrpc } from '@org/clients/community';
import type { UserSuggestion } from '@org/ui';

export function useMentionSearch() {
  const utils = communityTrpc.useUtils();
  return useCallback(
    async (query: string): Promise<UserSuggestion[]> => {
      if (!query) return [];
      const result = await utils.search.users.fetch({ query, limit: 8 });
      return (result?.users ?? []).map((u) => ({
        userId: u.userId,
        displayName:
          u.displayName?.trim() ||
          `${u.firstName ?? ''} ${u.lastName ?? ''}`.trim() ||
          'User',
        avatarUrl: u.profileImageUrl ?? null,
      }));
    },
    [utils]
  );
}
